import { NavigationMenu } from './route.model';

export const menuRoutes: NavigationMenu[] = [
  {
    menu: 'ASIGNACIÓN DE MENÚS',
    subMenu: [
      {
        name: 'Asignar Servicios A&B',
        icon: 'a-b-2',
        route: '/asignacion-menu',
      },
    ],
  },
  {
    menu: 'COCINA',
    subMenu: [
      {
        name: 'SKUs',
        icon: 'qrcode',
        route: '/cocina/skus',
      },
      {
        name: 'Platos',
        icon: 'soup',
        route: '/cocina/platos',
      },
      {
        name: 'Menús',
        icon: 'notebook',
        route: '/cocina/menus',
      },
    ],
  },
  {
    menu: 'GESTIÓN',
    subMenu: [
      {
        name: 'Ingresos',
        icon: 'arrow-right-to-arc',
        route: '/gestion/ingresos',
      },
      {
        name: 'Egresos',
        icon: 'arrow-right-from-arc',
        route: '/gestion/egresos',
      },
      {
        name: 'Kardex',
        icon: 'table',
        route: '/gestion/kardex',
      },
    ],
  },
  {
    menu: 'PROVEEDORES',
    subMenu: [
      {
        name: 'Proveedores',
        icon: 'users-group',
        route: '/proveedores',
      },
    ],
  },
  {
    menu: 'REPORTES',
    subMenu: [
      {
        name: 'Reporte Stock',
        icon: 'arrows-right-left',
        route: '/reportes',
      },
    ],
  },
  {
    menu: 'CUADRO PICNIC',
    subMenu: [
      {
        name: 'Cuadro Picnic',
        icon: 'grill',
        route: '/cuadro-picnic',
      },
    ],
  },
];
